import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assessmentsActions from '../../../redux/actions/assessmentsActions';

import AssessmentsSort from './AssessmentsSort';
import AssessmentsListItem from './AssessmentsListItem';
import AssessmentsListEmptyState from './AssessmentsListEmptyState';

class AssessmentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortKey: 'dateUpdated', // [dateCreated, dateUpdated, section, assessor]
      sortOrder: 'desc' // [asc, desc]
    };
  }

  toggleSort = (sortKey) => {
    // If we're already sorting by this key, toggle the sort order
    if (this.state.sortKey === sortKey) {
      let newSort = this.state.sortOrder === 'asc' ? 'desc' : 'asc';
      this.sort(sortKey, newSort);
    } else {
      this.sort(sortKey, 'asc');
    }
  }

  sort = (sortKey, sortOrder) => {
    this.setState({ sortKey, sortOrder });
  }

  render() {
    let assessments = Object.values(this.props.assessments)
      .sort((a, b) => {
        if (this.state.sortKey === 'dateUpdated') {
          return new Date(a.updatedAt) - new Date(b.updatedAt);
        } else if (this.state.sortKey === 'dateCreated') {
          let dateA = a.uploaded ? a.dateCompleted : a.createdAt;
          let dateB = b.uploaded ? b.dateCompleted : b.createdAt;
          return new Date(dateA) - new Date(dateB);
        } else if (this.state.sortKey === 'assessor') {
          if (a.lastEditedBy < b.lastEditedBy) return -1;
          else if (a.lastEditedBy > b.lastEditedBy) return 1;
          else return new Date(a.updatedAt) - new Date(b.updatedAt);
        } else { // section
          if (this.props.sections[a.section].title < this.props.sections[b.section].title) return -1;
          if (this.props.sections[a.section].title > this.props.sections[b.section].title) return 1;
          else return new Date(a.updatedAt) - new Date(b.updatedAt);
        }
      })
    if (this.state.sortOrder === 'desc') {
      assessments = assessments.reverse();
    }
    return (
      <div className="assessments-list">
        <AssessmentsSort
          toggleSort={this.toggleSort}
          sortKey={this.state.sortKey}
          sortOrder={this.state.sortOrder}
        />
        {assessments.length
          ? assessments.map(item => (
            <AssessmentsListItem
              key={item.id}
              item={item}
              enabled={
                (
                  // the selected section matches this item and this item is completed
                  (this.props.selectedSection === item.section && !item.uploaded && item.dateCompleted)
                  // or we haven't selected anything yet
                  || this.props.selectedSection === null
                ) && (
                  // and either we haven't selected three assessments yet
                  this.props.selectedAssessments.length <= 2
                  // or this is one of the ones we've selected
                  || this.props.selectedAssessments.indexOf(item.id) !== -1
                )}
              section={this.props.sections[item.section]}
              toggleCheckbox={() => this.props.toggleAssessment(item.id, item.section)}
              checked={this.props.selectedAssessments.indexOf(item.id) !== -1}
              user={this.props.users[item.lastEditedBy]}
              history={this.props.history}
              assessmentsActions={this.props.assessmentsActions}
            />
          )) : <AssessmentsListEmptyState />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    assessments: state.assessments.list,
    sections: state.sections,
    users: state.users.roster,
  };
}

function mapDispatchToProps(dispatch) {
  return { assessmentsActions: bindActionCreators(assessmentsActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssessmentsList);



// WEBPACK FOOTER //
// ./src/components/features/dashboard/AssessmentsList.js